import { render, staticRenderFns } from "./LeaderCourse.vue?vue&type=template&id=fe227cac&scoped=true&"
import script from "./LeaderCourse.vue?vue&type=script&lang=js&"
export * from "./LeaderCourse.vue?vue&type=script&lang=js&"
import style0 from "./LeaderCourse.vue?vue&type=style&index=0&id=fe227cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe227cac",
  null
  
)

export default component.exports